import React, { Component } from "react";
import Sockette from "sockette";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  messageAction,
  onOpen,
  error,
  getUnreadCount,
} from "./Actions/messagesAction";
import { getUserAction } from "./Actions/index";
import IndexPage from "./Components/Index";
import MainPage from "./Components/Main/main";
import SignUpPage from "./Components/Signup/signupMain";
import LoginPage from "./Components/Login/login";
import ForgotPasswordPage from "./Components/ForgotPassword/forgotPassword";
import Dashboard from "./Components/BusinessPortal/Index";
import { Switch, Route, withRouter } from "react-router-dom";
import PrivateRoute from "./Components/RouteTypes/privateRoute";
import PublicRoute from "./Components/RouteTypes/publicRoute";
import PaymentRoute from "./Components/RouteTypes/paymentRoute";
import AccountRoute from "./Components/RouteTypes/accountRoute";
import "./App.css";
import { routeName } from "../src/Service/env";
import Payment from "./Components/Signup/paymentInfo";
import ErrorPage from "./Helper/ErrorPage/errorPage";
import LoginLoader from "./Helper/loader/loginLoader";
import { getAppointment } from "./Actions/appointmentAction";
import FloatChat from "./Components/BusinessPortal/Messages/FloatChat/floatChat";
import { Notifications } from "react-push-notification";
import Toast from "./Helper/Toast/Toast";

export let ws = null;

class App extends Component {
  componentDidMount() {
    let date = new Date();
    ws = new Sockette("wss://socket.ubme.com/", {
      // ws = new Sockette("ws://127.0.0.1:80/",{
      protocol: "echo-protocol",
      onopen: (e) => {
        if (
          this.props.user &&
          this.props.user.AppUser &&
          this.props.user.AppUser.UserId
        ) {
          ws.json({
            token_id: localStorage.getItem("token"),
            user_id: this.props.user.AppUser.UserId.toString(),
            type: "identity",
            isOnline: 1,
            msgid: date.getTime().toString().slice(4),
          });
          ws.json({
            user_id: this.props.user.AppUser.UserId.toString(),
            type: "recentchat",
            count: 20,
            index: 1,
          });
          this.props.getUnreadCount();
        }
        this.props.onOpen("Open");
      },
      onmessage: (e) => {
        this.props.messageAction(e);
      },
      onreconnect: (e) => {
        let { user } = this.props;
        if (
          this.props.user &&
          this.props.user.AppUser &&
          this.props.user.AppUser.UserId
        ) {
          ws.json({
            token_id: localStorage.getItem("token"),
            user_id: user.AppUser.UserId.toString(),
            type: "identity",
            isOnline: 1,
            msgid: date.getTime().toString().slice(4),
          });
        }
        this.props.onOpen("Open");
        this.props.error("sc");
      },
      onmaximum: (e) => console.log("Stop Attempting..!!"),
      onclose: (e) => {
        if (this.props.user.AppUser && this.props.user.AppUser.UserId) {
          ws.json({
            type: "disconnect",
            userId: this.props.user.AppUser.UserId.toString(),
            tokenId: localStorage.getItem("token"),
          });
        }
      },
      onerror: (e) => {
        console.log(e);
        this.props.error("Cannot connect to server.");
      },
    });

    this.props.getUserAction();

    // setTimeout(() => {
    //     if (this.props && this.props.user && this.props.user.BusinessUser && this.props.user.BusinessUser.AppointmentFormId) {
    //         const appointmentCount = localStorage.getItem('appointmentCount');
    //         if (appointmentCount === null || appointmentCount === "" || appointmentCount === 'undefined' || appointmentCount === '0') {
    //             this.props.getAppointment(`https://api.jotform.com/form/${this.props.user.BusinessUser.AppointmentFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672`);
    //         }
    //
    //         if(this.props && !this.props.IsAppointmentTimerSet) {
    //             // this.props.IsAppointmentTimerSet = true
    //             this.interval = setInterval(() => {
    //                     this.props.getAppointment(`https://api.jotform.com/form/${this.props.user.BusinessUser.AppointmentFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672`);
    //                 }, 60000
    //             );
    //         }
    //     }
    // }, 1000);
  }
  render() {
    return (
      <React.Fragment>
        <LoginLoader />
        <Notifications position={"bottom-right"} />
        <Toast
          toastList={this.props.toastList}
          position={"bottom-right"}
          autoDelete={false}
          autoDeleteTime={1000}
        />
        <FloatChat />
        <Switch>
          <PublicRoute exact path={`/`} component={IndexPage} onpage={true} />
          <PublicRoute
            exact
            path={`/${routeName}`}
            component={MainPage}
            onpage={false}
          />
          <PublicRoute
            exact
            path={`/${routeName}/Signup`}
            component={SignUpPage}
            onpage={false}
          />
          <PublicRoute
            exact
            path={`/${routeName}/Login`}
            component={LoginPage}
            onpage={false}
          />
          <PublicRoute
            exact
            path={`/${routeName}/ForgotPassword`}
            component={ForgotPasswordPage}
            onpage={false}
          />
          <PaymentRoute
            exact
            path={`/${routeName}/Payment`}
            component={Payment}
            user={this.props.user}
            withTrial={true}
          />
          <AccountRoute
            exact
            path={`/${routeName}/Dashboard/MyAccount`}
            component={Dashboard}
            user={this.props.user}
          />
          <PrivateRoute
            path={`/${routeName}/Dashboard`}
            component={Dashboard}
            user={this.props.user}
          />
          <Route path="*" component={ErrorPage} />
        </Switch>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.loginResponse.results,
    toastList: state.messageReducer.toastList,
  };
};

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      messageAction,
      onOpen,
      getUserAction,
      getAppointment,
      error,
      getUnreadCount,
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(App));
